import { Divider } from '@mui/material';
import { InputDropdownInput } from './InputDropdownInput';
import { InputDropdownSelect } from './InputDropdownSelect';
import { InputDropdownContent } from './styles';
import { useState } from 'react';
import { InputError, TextS } from '../typography';

const CustomDivider = () => {
  return (
    <div style={{ margin: '0px 12px' }}>
      <Divider sx={{ height: '25px', width: '3px' }} orientation="vertical" />
    </div>
  );
};

export enum EInputType {
  CURRENCY = 'CURRENCY',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT',
}

export type TFilterItems = {
  name: string;
  parameterName: string;
  type?: EInputType;
};

export interface IInputDropdownProps {
  items: TFilterItems[];
  inputValue: string;
  label?: string;
  selectedFilter?: string | undefined;
  validationError?: string;
  handleInputChange: (value: string) => void;
  handleSelectFilterItem: (filterSelectedValue: TFilterItems) => void;
  disabled?: boolean;
}

const InputDropdown = ({
  inputValue,
  items,
  validationError,
  label,
  selectedFilter,
  handleInputChange,
  handleSelectFilterItem,
  disabled,
}: IInputDropdownProps) => {
  const [isOpenSelect, setIsOpenSelect] = useState(false);
  const handleClose = () => {
    setIsOpenSelect(false);
  };

  const handleSelectedFilter = (selectElementValue: TFilterItems) => {
    handleSelectFilterItem(selectElementValue);
  };

  const handleOpen = () => {
    setIsOpenSelect(true);
  };

  const selectedItem =
    items.find((item) => item.parameterName === selectedFilter) ?? items[0];

  return (
    <>
      {typeof label === 'string' && (
        <TextS className="label" weight="Bold" style={{ marginBottom: '10px' }}>
          {label}
        </TextS>
      )}
      <InputDropdownContent disabled={disabled}>
        <InputDropdownSelect
          handleClose={handleClose}
          handleOpen={handleOpen}
          isOpen={isOpenSelect}
          selectedElement={selectedFilter}
          items={items}
          handleSelectFilter={(selectElementValue) =>
            handleSelectedFilter(selectElementValue)
          }
        />
        <CustomDivider />
        <InputDropdownInput
          value={inputValue}
          selectedItem={
            selectedItem || [
              { name: '-', parameterName: '-', type: EInputType.TEXT },
            ]
          }
          handleInputChange={(value) => handleInputChange(value)}
        />
      </InputDropdownContent>
      {typeof validationError === 'string' && (
        <InputError>{validationError}</InputError>
      )}
    </>
  );
};

export default InputDropdown;
